<script setup>
import { computed, onMounted, ref } from "vue";
import UserAuth from "../../../components/UserAuth/UserAuth.vue";
import { useUsuarioStore } from "../../../store/usuarioStore";

const registerEndedSuccessfully = computed(() => usuarioStore.registerEndedSuccessfully);
const usuarioStore = useUsuarioStore()


const registrarUsuario = async () => {
  const res = await usuarioStore.registrarUsuario();
  if(res === true) {
     usuarioStore.registerEndedSuccessfully = true;
  }
};

// ---- UI helpers (ojo + reglas password) ----
const showPassword = ref(false);
const showPasswordRepeat = ref(false);



const password = computed(() => usuarioStore.user.password ?? "");

const onInvalidterminos = (e) => {
  if (!e.target.checked) {
    e.target.setCustomValidity('Debes aceptar los términos y condiciones del sitio.');
  }
};

const clearTerminosMsg = (e) => {
  e.target.setCustomValidity('');
};

const onInvalidDdjj = (e) => {
  if (!e.target.checked) {
    e.target.setCustomValidity('Debes aceptar la Declaración de Privacidad y Confidencialidad.');
  }
};

const clearDdjjMsg = (e) => {
  e.target.setCustomValidity('');
};

const rules = computed(() => {
  const pwd = password.value;

const minLen = pwd.length >= 8;
const upper = /[A-Z]/.test(pwd);
const lower = /[a-z]/.test(pwd);
const number = /\d/.test(pwd);
const symbol = /[@$!%*#?&.\-_]/.test(pwd);
const allowedOnly = /^[A-Za-z0-9@$!%*#?&.\-_]+$/.test(pwd);


  return {
    minLen,
    upper,
    lower,
    number,
    symbol,
    allowedOnly,
  };
});
onMounted(() => {
    usuarioStore.obtenerReferencias();
});

const ruleIcon = (ok) => (ok ? "✓" : "✗");
</script>

<template>
  <UserAuth :usuarioStore="usuarioStore">
    <div v-if="!registerEndedSuccessfully" class="w-100 p-2" style="max-width: 400px">
      <h2 class="fw-bold mb-2">Registrate</h2>

      <p class="text-muted mb-2" style="font-size: 0.95rem; line-height: 1.35">
        Completá tu registro para acceder a nuestras dos modalidades de subastas:
        <a href="#" class="fw-bold text-primary text-decoration-none">Subastas en vivo</a>
        y
        <a href="#" class="fw-bold text-primary text-decoration-none">Subastas cronometradas</a>
      </p>

      <div class="mb-3" style="font-size: 0.95rem">
        <span class="text-muted me-1">¿Ya tenés una cuenta?</span>
        <button
          type="button"
          class="login-link-button text-primary fw-bold text-decoration-none"
          @click="$router.push('/login')"
        >
           Ingresá
        </button>
      </div>

      <form @submit.prevent="registrarUsuario()">
        <div class="mb-3">
          <label for="email" class="form-label fw-semibold">Email</label>
          <input
            id="email"
            type="email"
            class="form-control"
            v-model.trim="usuarioStore.user.email"
            autocomplete="email"
            required
          />
        </div>

        <!-- Password + ojo -->
        <div class="mb-2">
          <label for="password" class="form-label fw-semibold">Contraseña</label>
          <div class="input-group">
            <input
              id="password"
              :type="showPassword ? 'text' : 'password'"
              class="form-control"
              v-model="usuarioStore.user.password"
              autocomplete="new-password"
              required
            />
            <button
              class="btn btn-outline-secondary"
              type="button"
              @click="showPassword = !showPassword"
              aria-label="Mostrar/ocultar contraseña"
            >
              <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
          </div>

          <!-- Reglas password (como en la imagen, en rojo) -->
          <div class="mt-2">
            <div class="fw-semibold" style="font-size: 0.9rem">Crea una contraseña segura:</div>
            <ul class="mb-0 ps-3" style="color: #d32f2f; font-size: 0.9rem; line-height: 1.35">
              <li :class="rules.minLen ? 'text-success' : 'text-error'">
                <small>
                    <strong>
                        {{ ruleIcon(rules.minLen) }} Mínimo 8 caracteres
                    </strong>
                </small>
              </li>
              <li :class="rules.upper ? 'text-success' : 'text-error'">
                <small>
                    <strong>
                        {{ ruleIcon(rules.upper) }} Una letra mayúscula
                    </strong>
                </small>
              </li>
              <li :class="rules.lower ? 'text-success' : 'text-error'">
                <small>
                    <strong>
                        {{ ruleIcon(rules.lower) }} Una letra minúscula
                    </strong>
                </small>
              </li>
              <li :class="rules.number ? 'text-success' : 'text-error'">
                <small>
                    <strong>
                        {{ ruleIcon(rules.number) }} Un número
                    </strong>
                </small>
              </li>
              <li :class="rules.symbol ? 'text-success' : 'text-error'">
                <small>
                    <strong>
                        {{ ruleIcon(rules.symbol) }} Un símbolo (por ejemplo: ! @ # $ %)
                    </strong>
                </small>
              </li>
              <li :class="rules.allowedOnly ? 'text-success' : 'text-error'">
                <small>
                    <strong>
                        {{ ruleIcon(rules.allowedOnly) }} Solo letras, números y símbolos permitidos (@ $ ! % * # ? &amp; . -)
                    </strong>
                </small>
              </li>
            </ul>
          </div>
        </div>

        <!-- Repeat password + ojo -->
        <div class="mb-3">
          <label for="repeat-password" class="form-label fw-semibold">Repetir contraseña</label>
          <div class="input-group">
            <input
              id="repeat-password"
              :type="showPasswordRepeat ? 'text' : 'password'"
              class="form-control"
              v-model="usuarioStore.user.password_confirmation"
              autocomplete="new-password"
              required
            />
            <button
              class="btn btn-outline-secondary"
              type="button"
              @click="showPasswordRepeat = !showPasswordRepeat"
              aria-label="Mostrar/ocultar repetir contraseña"
            >
              <i :class="showPasswordRepeat ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
            </button>
          </div>
        </div>

            <div class="mb-3">
                <label for="source" class="form-label">¿Cómo te enteraste de Adrián Mercado?*</label>
                <select class="form-select" v-model = usuarioStore.referencia_id  id="source">
                    <option  :value="null" selected>Seleccionar</option>
                    <option v-for="referencia in usuarioStore.referencias" :key="referencia.id" :value="referencia.id">
                        {{ referencia.descripcion }}
                    </option>
                  
                </select>
            </div>

            <div class="form-check mb-2">
                <input 
                  type="checkbox" 
                  class="form-check-input" 
                  v-model ="usuarioStore.user.acepta_terminos" 
                  id="terms"
                  @invalid="onInvalidterminos"
                  @change="clearTerminosMsg"    
                  required>
                <label class="form-check-label" for="terms">
                    He leído y acepto los <a href="#" class="fw-bold text-decoration-none">Términos y Condiciones del Sitio</a>
                </label>
            </div>

            <div class="form-check mb-4">
                <input 
                type="checkbox" 
                class="form-check-input" 
                v-model='usuarioStore.user.acepta_ddjj' 
                id="privacy" 
                @invalid="onInvalidDdjj"
                @change="clearDdjjMsg"  
                required>
                <label class="form-check-label" for="privacy">
                    He leído y acepto la <a href="#" class="fw-bold text-decoration-none">Declaración de Privacidad y Confidencialidad de la Información</a>
                </label>
            </div>

        <!-- Button -->
        <button type="submit" class="btn btn-primary w-100 fw-bold py-2">
          Registrarme
        </button> 
      </form>
    </div>
      <div v-else class="w-100 p-2" style="max-width: 400px">
      <div class="card">
        <div class="card-body">
          <h2 class="fw-bold mb-2">Registro exitoso</h2>
          <p class="text-muted mb-2" style="font-size: 0.95rem; line-height: 1.35">
            ¡Gracias por registrarte! Por favor, revisa tu correo electrónico para verificar tu cuenta y completar el proceso de registro. Podés cerrar esta pantalla.
          </p>
        </div>
      </div>
    </div>
  </UserAuth>
</template>

<style scoped lang="scss">
.login-link-button {
  border: 0;
  background: transparent;
  padding: 0;
}
</style>
